import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import { getRequestParam } from '../utils';
import * as commonActions from '../actions/common';
import { LANGUAGES } from '../constants';

import Header from './Header';
import Footer from './Footer';
import MobileWrapperMask from './MobileWrapperMask';
import MobileLeftPanel from './MobileLeftPanel';
import MobileRightPanel from './MobileRightPanel';
import PasswordUpdateNotice from './PasswordUpdateNotice';

class App extends React.Component {
	constructor(props) {
		super(props);
	}
	
	componentWillMount() {
		// get locale_name from url and set language, locale_name is set by other websites
		var country = this.props.location.query['locale_name'];
		if(country) LANGUAGES.map((item,index)=>{
			if(item.country==country) this.props.changeLanguageAction(LANGUAGES[index]);
		});
		// get session_key from url
		var sessionKey = getRequestParam('session_key')
		// init global store
		if(this.props.location.pathname!='/error_link'){
			this.props.initData();
		}
		// remove session_key from url
		if (sessionKey) {
			let search;
			const cpn = getRequestParam('cpn');
			if (cpn) search = '?cpn=' + cpn;
			browserHistory.push({
				pathname: window.location.pathname,
				search,
			});
		}
	}
	render() {
		return (
			<div key={this.props.language.lang}>
				<div className="wrapper">
					<Header />
					{ this.props.children }
					<Footer />
					<MobileWrapperMask />
				</div>
				<MobileLeftPanel />
				<MobileRightPanel />
				<PasswordUpdateNotice userInfo={this.props.userInfo} />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		language: state.data.language
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, commonActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./app/components/App.js